import ListModalAntd from "@/components/ListModalAntd";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  useAccount,
  useBalance,
  useGasPrice,
  useSendTransaction,
  useWaitForTransactionReceipt,
} from "wagmi";
import { useWalletClient, usePublicClient } from "wagmi";
import { setBalance, waitForTransactionReceipt } from "viem/actions";
import "./index.less";
import PageHead from "@/components/PageHead";
import SafetyWarning from "@/components/SafetyWarning";
import { removeTrailingZeros } from "@/utils/methods";
import { Ed25519Keypair } from "@mysten/sui/keypairs/ed25519";
import {
  Alert,
  Divider,
  Form,
  Input,
  Modal,
  Popover,
  Segmented,
  Spin,
  message,
} from "antd";
import { useTranslation } from "react-i18next";
import WalletOperate from "./components/WalletOperate";
import PrivateKeyOperate from "./components/PrivateKeyOperate";
import { Address, formatUnits, parseEther, parseUnits } from "viem";
import { cdnUrl } from "@/utils/cdn";
import { isAddress, Wallet } from "ethers";
import { CopyOutlined, LoadingOutlined } from "@ant-design/icons";
import { downloadFile } from "@/utils/downloadFile";
import SelectImgAntd from "@/components/SelectImgAntd";
import MyModal from "./components/MyModal";
import { sendTransactions, sendAllBNB, sendTransfer } from "@/services";
import { useFeeData } from "@/hooks/useFeeData";
import { formatAddress, isValidSuiAddress } from "@mysten/sui/utils";
import { useCurrentAccount, useSignAndExecuteTransaction } from "@mysten/dapp-kit";
import { DEFAULT_RPC } from "@/config";

import { SuiClient, getFullnodeUrl } from "@mysten/sui/client";
import { Transaction } from "@mysten/sui/transactions";
import { decodeSuiPrivateKey } from "@mysten/sui/cryptography";

import { Secp256k1Keypair } from "@mysten/sui/keypairs/secp256k1";
import { Secp256r1Keypair } from "@mysten/sui/keypairs/secp256r1";

import { isValidSuiPrivateKey } from "@/utils/check";
import { FEE_ADDRESS } from "@/config/feeAddress";
const FEE = 0.1;
const oneTimeTransferGas = parseUnits("0.0044", 9)
const IntermediaryTransfer = () => {

  const client = new SuiClient({
    url: DEFAULT_RPC,
  });
  const SUI_DECIMALS = 9;
  const { mutateAsync: signAndExecute } = useSignAndExecuteTransaction(); // ✅ 取代 signer

  const account = useCurrentAccount();
  // console.log("account", account)

  const [form] = Form.useForm();
  const transferTimes = Form.useWatch("transferTimes", form);
  const transferAmount = Form.useWatch("transferAmount", form);
  const acceptAddress = Form.useWatch("acceptAddress", form);
  // const  = Form.useWatch("transferAmount", form);
  const [ultimateReceiveAmount, setUltimateReceiveAmount] = useState("");
  const [messageApi, contextHolder] = message.useMessage();

  const { address } = useAccount();

  // console.log("balance", balance);
  const { t, i18n } = useTranslation();

  const [walletType, setWalletType] = useState("walletOperate");
  const [hash, setHash] = useState<`0x${string}` | undefined>(undefined);
  const [privateAddress, setPrivateAddress] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [privateKeyBalance, setPrivateKeyBlance] = useState("0")
  // const [transferAmount, setTransferAmount] = useState("");
  // const [transferTimes, setTransferTimes] = useState("10");
  // const [acceptAddress, setAcceptAddress] = useState("");
  const [isGeneratingAdrs, setIsGeneratingAdrs] = useState(false);
  const [isTransfering, setIsTransfering] = useState(false);
  // "" loading error success
  const [step1Status, setStep1Status] = useState("loading");
  const [step2Status, setStep2Status] = useState("");
  const [step3Status, setStep3Status] = useState("");
  const [balance, setBalance] = useState("");
  const [adrs, setAdrs]: any[] = useState([]);
  // console.log("adrs", adrs);
  // const [adrsObj,setAdrsObj]=useState([])
  const [isFinishTransfer, setIsFinishtransfer] = useState(false);
  //温馨提示框
  const [isTransferHintModalOpen, setIsTransferHintModalOpen] = useState(false);
  //loading框
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);
  // 成功框
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [width, setWidth] = useState("0");
  const [finishedAmount, setFinishAmount] = useState(0);
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const tokenModalRef = useRef(null);
  const getBalance = async (isWallet?: Boolean) => {
    const balanceres = await client.getBalance({
      owner: (isWallet ? account?.address : privateAddress) || "",
    })
    if (isWallet) {
      setBalance(balanceres.totalBalance)
    } else {
      setPrivateKeyBlance(balanceres.totalBalance)
    }

    // console.log("balanceres", balanceres)
  }

  const { isSuccess, isError } = useWaitForTransactionReceipt({
    hash,
  });



  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    messageApi.open({
      type: "success",
      // content: "复制成功",
      content: t("customizedAuthorization.pasteSuccess"),
    });
  };
  useEffect(() => {
    if (isSuccess) {
      // setIsLoadingModalOpen(true);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      setIsErrorModalOpen(true);
    }
  }, [isError]);

  useEffect(() => {
    if (btnRef.current) {
      setWidth(btnRef.current.offsetWidth + "px");
      // console.log("btnRef", btnRef.current.offsetWidth);
    }
  }, [adrs]);


  useEffect(() => {

  }, [])
  useEffect(() => {
    if (account) {
      getBalance(true)
    } else {
      setBalance("0")
    }
  }, [account])

  useEffect(() => {
    if (privateKey && isValidSuiPrivateKey(privateKey)) {
      getBalance(false)
    } else {
      setPrivateKeyBlance("0")
    }

  }, [privateKey])

  // console.log("balance", balance);
  const content = (
    <div className="pop-content" style={{ width: "480px" }}>
      <div onClick={() => downloadFile(adrs, "xlsx")}>Excel</div>
      <div onClick={() => downloadFile(adrs, "csv")}>CSV</div>
      <div onClick={() => downloadFile(adrs, "txt")}>TXT</div>
      <div onClick={() => downloadFile(adrs, "json")}>Json</div>
    </div>
  );

  const hintcontent = (
    <div className="pop-content" style={{ width: "210px" }}>
      <div onClick={() => downloadFile(adrs, "xlsx")}>Excel</div>
      <div onClick={() => downloadFile(adrs, "csv")}>CSV</div>
      <div onClick={() => downloadFile(adrs, "txt")}>TXT</div>
      <div onClick={() => downloadFile(adrs, "json")}>Json</div>
    </div>
  );
  //   console.log("account", account);
  const options = useMemo(
    () => [
      {
        label: t("customizedAuthorization.walletOperation"),
        value: "walletOperate",
      },
      {
        label: t("customizedAuthorization.privateKeyOperation"),
        value: "privateKeyOperate",
      },
    ],
    [t]
  );
  const fGenerateAddress = () => {
    setIsGeneratingAdrs(true);

    setTimeout(() => {
      const data: { address: string; privateKey: string }[] = [];
      const count = Number(transferTimes) || 0;

      for (let i = 0; i < count; i++) {
        // 兼容不同版本 SDK
        const keypair =
          typeof (Ed25519Keypair as any).generate === "function"
            ? (Ed25519Keypair as any).generate()
            : new Ed25519Keypair();

        const address = keypair.getPublicKey().toSuiAddress();

        // 通常为 suiprivkey1... 格式
        const privateKey = keypair.getSecretKey();

        data.push({ address, privateKey });
      }

      setAdrs([...data]);
      downloadFile(data, "xlsx");
      setIsGeneratingAdrs(false);
    }, 0);
  };

  const funTranfer = async () => {
    if (
      walletType == "walletOperate" &&
      Number(formatUnits(BigInt(balance), 9)) <=
      Number(transferAmount) + Number(formatUnits(BigInt(transferTimes) * FEE_ADDRESS.sui.IntermediaryTransfer.serviceFee, 9))
    ) {

      messageApi.open({
        type: "warning",
        content: t("tips.insufficientBalance"),
      });
      return;
    }
    if (
      walletType == "privateKeyOperate" &&
      Number(formatUnits(BigInt(privateKeyBalance), 9)) <=
      Number(transferAmount) + Number(formatUnits(BigInt(transferTimes) * FEE_ADDRESS.sui.IntermediaryTransfer.serviceFee, 9))
    ) {
      messageApi.open({
        type: "warning",
        content: t("tips.insufficientBalance"),
      });
      return;
    }
    if (walletType == "walletOperate" && !address) {
      messageApi.open({
        type: "warning",
        content: t("customizedAuthorization.pleaseConnectWallet"),
      });
      return;
    }
    if (walletType == "privateKeyOperate" && !isValidSuiAddress(privateAddress)) {
      messageApi.open({
        type: "warning",
        content: t("customizedAuthorization.pleaseEnterCorrectPrivateKey"),
      });
      return;
    }
    try {
      const values = form.getFieldsValue();
      // console.log("values", values);
      await form.validateFields();
      // console.log("values", values);
      setIsTransferHintModalOpen(true);
    } catch (error) { }
  };

  const sendServiceFeeAndTransferToFirstWallet = (tx: any, serviceFee: bigint, serviceFeeReciver: string, firstAddress: string, transferAmount: bigint) => {
    const [feeCoin, transferCoin] = tx.splitCoins(
      tx.gas,
      [tx.pure.u64(serviceFee), tx.pure.u64(transferAmount)],
    );
    tx.transferObjects(
      [feeCoin],
      tx.pure.address(serviceFeeReciver),
    );
    tx.transferObjects(
      [transferCoin],
      tx.pure.address(firstAddress)
    )
  }

  // 兼容三种签名方案（Ed25519 / Secp256k1 / Secp256r1）:contentReference[oaicite:2]{index=2}
  function keypairFromSuiPrivateKey(privkey: string) {
    const decoded: any = decodeSuiPrivateKey(privkey.trim());
    const scheme = decoded.scheme ?? decoded.schema;
    const secretKey: Uint8Array = decoded.secretKey;

    switch (scheme) {
      case "ED25519":
        return Ed25519Keypair.fromSecretKey(secretKey);
      case "Secp256k1":
        return Secp256k1Keypair.fromSecretKey(secretKey);
      case "Secp256r1":
        return Secp256r1Keypair.fromSecretKey(secretKey);
      default:
        throw new Error(`Unsupported scheme: ${scheme}`);
    }
  }

  /**
 * 尽可能把 sender 的所有 SUI 转给 recipient
 * - 如果有多个 SUI coin：交给 SDK 做 gasPayment 合并 :contentReference[oaicite:3]{index=3}
 * - gasBudget 默认 dry-run 自动估算 :contentReference[oaicite:4]{index=4}
 * 最终到账 ≈ 总余额 - 实际 gas
 */
  async function sweepAllSui(
    privateKey: string,
    recipient: string,
  ) {
    if (!isValidSuiAddress(recipient)) {
      throw new Error("Invalid recipient Sui address.");
    }

    const signer = keypairFromSuiPrivateKey(privateKey);

    const sender =
      (signer as any).toSuiAddress?.() ??
      signer.getPublicKey().toSuiAddress();
    // console.log("sender", sender)
    const coins = await client.getBalance({
      owner: sender
    });
    // console.log("coins", coins)
    // if (coins.length === 0) {
    //   throw new Error("No SUI balance.");
    // }
    const tx = new Transaction();
    // 不手动 setGasBudget，交给 SDK 自动 dry-run 推导 :contentReference[oaicite:6]{index=6}
    // 关键：把 gas coin 自己转走，实现“尽可能清空”
    tx.transferObjects([tx.gas], recipient);

    const result = await client.signAndExecuteTransaction({
      signer,
      transaction: tx,
      options: {
        showEffects: true,
        showBalanceChanges: true,
      },
    });
    await client.waitForTransaction({ digest: result.digest });
    return {
      digest: result.digest,
      sender,
      recipient,
    };
  }

  // console.log("balance", balance)
  // console.log("adrs", adrs)
  // console.log("transferAmount", transferAmount)

  const calcUltimateReiveAmount = async (digest: string) => {
    const res: any = await client.getTransactionBlock({
      digest,
      options: {
        showInput: true,
        showEffects: true,
        showEvents: true,
        showBalanceChanges: true,
        showObjectChanges: true,
      },
    });
    return (res?.balanceChanges[1].amount) || 0
  }

  async function getAllSuiCoins(owner: string) {
    const coinType = "0x2::sui::SUI";
    let cursor: string | null | undefined = null;
    const all: any[] = [];

    do {
      const page = await client.getCoins({
        owner,
        coinType,
        cursor,
        limit: 50,
      });
      all.push(...page.data);
      cursor = page.hasNextPage ? page.nextCursor : null;
    } while (cursor);

    return all;
  }


  async function mergeSplitAndSendSui(
    privateKey: string,
    opts: any
  ) {
    const {
      to1,
      to2,
      amount1Mist,
      amount2Mist,
      gasBudget = 20_000_000,
      // 给自己留一点 gas 缓冲，避免你把余额拆太满
      reserveGasMist = 30_000_000n, // 0.03 SUI
    } = opts;

    if (!to1 || !to2) throw new Error("缺少 to1 / to2");
    if (amount1Mist == null || amount2Mist == null) {
      throw new Error("请传入 amount1Mist 和 amount2Mist（单位 MIST）");
    }

    const a1 = BigInt(amount1Mist);
    const a2 = BigInt(amount2Mist);
    if (a1 <= 0n || a2 <= 0n) throw new Error("拆分金额必须 > 0");

    const keypair = keypairFromSuiPrivateKey(privateKey);
    const owner = keypair.getPublicKey().toSuiAddress();

    // 1) 查询该地址所有 SUI coins
    const coins = await getAllSuiCoins(owner);
    if (!coins.length) {
      throw new Error("该地址没有可用的 SUI Coin");
    }

    const getBal = (c: any) => BigInt(c.balance ?? c.coinBalance ?? 0);

    // 2) 选最大那枚作 gas coin
    const sorted = [...coins].sort((x, y) => {
      const bx = getBal(x);
      const by = getBal(y);
      return by > bx ? 1 : by < bx ? -1 : 0;
    });

    const gasCoin = sorted[0];
    const mergeSources = sorted.slice(1);

    const total = sorted.reduce((acc, c) => acc + getBal(c), 0n);

    // 3) 防呆：别把余额拆太满
    const need = a1 + a2 + reserveGasMist;
    if (total < need) {
      throw new Error(
        `余额不足以拆分并预留 gas。total=${total.toString()} need=${need.toString()}`
      );
    }

    // 4) 构建交易
    const tx = new Transaction();

    // 4.1 显式设置 gas payment（用对象引用）
    const gasObj = await client.getObject({
      id: gasCoin.coinObjectId,
      options: { showContent: false },
    });

    if (!gasObj.data) {
      throw new Error("无法获取 gas coin 对象引用");
    }

    const gasRef = {
      objectId: gasObj.data.objectId,
      version: gasObj.data.version,
      digest: gasObj.data.digest,
    };

    // 某些版本类型定义较严格
    // @ts-ignore
    tx.setGasPayment([gasRef]);

    tx.setGasBudget(Number(gasBudget));

    // 关键点：主 coin 用 tx.gas
    const primary = tx.gas;

    // 4.2 先合并其它 coins -> gas coin
    if (mergeSources.length) {
      tx.mergeCoins(
        primary,
        mergeSources.map((c) => tx.object(c.coinObjectId))
      );
    }

    // 4.3 再拆两个 coin
    const [c1, c2] = tx.splitCoins(primary, [
      tx.pure.u64(a1.toString()),
      tx.pure.u64(a2.toString()),
    ]);

    // 4.4 分别转给两个地址
    tx.transferObjects([c1], tx.pure.address(to1));
    tx.transferObjects([c2], tx.pure.address(to2));

    // 5) 签名并发送
    const res = await client.signAndExecuteTransaction({
      signer: keypair,
      transaction: tx,
      options: {
        showEffects: true,
        showObjectChanges: true,
        showBalanceChanges: true,
      },
    });

    // 6) 等待链上确认
    const ultimateRes = await client.waitForTransaction({
      digest: res.digest,
      options: { showEffects: true },
      timeout: 60_000,
      pollInterval: 2_000,
    });

    const status = ultimateRes.effects?.status.status;
    const error = ultimateRes.effects?.status.error;

    if (status !== "success") {
      throw new Error(error || "Transaction failed");
    }

    return {
      owner,
      totalBalanceMist: total.toString(),
      amount1Mist: a1.toString(),
      amount2Mist: a2.toString(),
      digest: res.digest,
      effects: res.effects,
    };
  }

  async function sweepAllSui1(
    privateKey: string,
    to: string,
    opts: { gasBudget?: number } = {}
  ) {
    const gasBudget = opts.gasBudget ?? 5_000_000; // 更保守：0.005 SUI 左右

    const keypair = keypairFromSuiPrivateKey(privateKey);
    const owner = keypair.getPublicKey().toSuiAddress();

    const coins = await getAllSuiCoins(owner);
    if (!coins.length) throw new Error("该地址没有可用的 SUI Coin");

    const getBal = (c: any) => BigInt(c.balance ?? c.coinBalance ?? 0);

    // 按余额从大到小
    const sorted = [...coins].sort((a, b) => {
      const ba = getBal(a);
      const bb = getBal(b);
      return bb > ba ? 1 : bb < ba ? -1 : 0;
    });

    // ====== 只有 1 枚 SUI Coin：无法“真全清”，必须留 gas ======
    if (sorted.length === 1) {
      const only = sorted[0];
      const bal = getBal(only);

      const reserve = BigInt(gasBudget) * 2n; // 留两倍预算更稳
      if (bal <= reserve) {
        throw new Error("余额太少，无法预留 gas 后转出");
      }

      const sendAmount = bal - reserve;

      const tx = new Transaction();
      const primary = tx.object(only.coinObjectId);

      const [pay] = tx.splitCoins(primary, [
        tx.pure.u64(sendAmount.toString()),
      ]);

      tx.transferObjects([pay], tx.pure.address(to));
      tx.setGasBudget(gasBudget);

      const res = await client.signAndExecuteTransaction({
        signer: keypair,
        transaction: tx,
        options: { showEffects: true },
      });

      return { owner, digest: res.digest };
    }

    // ====== 多枚 SUI Coin：留一枚最小的专门给系统当 gas ======
    // gas 预留：取最小那枚
    const asc = [...sorted].sort((a, b) => {
      const ba = getBal(a);
      const bb = getBal(b);
      return ba > bb ? 1 : ba < bb ? -1 : 0;
    });

    const gasReserveCoin = asc[0];              // 不引用它
    const primaryCoin = sorted[0];             // 最大那枚做主
    const mergeSources = sorted
      .filter(
        (c) =>
          c.coinObjectId !== gasReserveCoin.coinObjectId &&
          c.coinObjectId !== primaryCoin.coinObjectId
      );

    const tx = new Transaction();
    const primary = tx.object(primaryCoin.coinObjectId);

    // 先合并除 gasReserveCoin 外的所有 coins 进 primary
    if (mergeSources.length) {
      tx.mergeCoins(
        primary,
        mergeSources.map((c) => tx.object(c.coinObjectId))
      );
    }

    // 再把 primary 整个转走
    tx.transferObjects([primary], tx.pure.address(to));

    // 关键：不要 setGasPayment，不要引用 gasReserveCoin
    tx.setGasBudget(gasBudget);

    const res = await client.signAndExecuteTransaction({
      signer: keypair,
      transaction: tx,
      options: { showEffects: true },
    });

    return { owner, digest: res.digest };
  }




  const funStartTransfer = async () => {
    // console.log("开始转账");
    setUltimateReceiveAmount("")
    setIsTransferHintModalOpen(false);
    setIsLoadingModalOpen(true);
    if (walletType === "walletOperate") {
      try {
        // 1) 发送服务费（连接钱包）
        const tx = new Transaction();
        sendServiceFeeAndTransferToFirstWallet(
          tx,
          FEE_ADDRESS.sui.IntermediaryTransfer.serviceFee * BigInt(adrs.length),
          FEE_ADDRESS.sui.IntermediaryTransfer.serviceFeeReciver,
          adrs[0].address,
          parseUnits(String(transferAmount), 9)
        )
        const res = await signAndExecute({
          transaction: tx,
        });
        const ultimateRes = await client.waitForTransaction({
          digest: res.digest,
          options: {
            showEffects: true,
          },
          timeout: 60_000,
          pollInterval: 2_000,
        })
        const status = ultimateRes.effects?.status.status;
        const error = ultimateRes.effects?.status.error;
        // console.log("ultimateResXXXX", ultimateRes)
        if (status !== 'success') {
          throw new Error(error);
        }
        setStep1Status("success");
        // 2) 中转地址列表 + 最终收款地址
        const ultimateAdrsL = [...adrs, { address: acceptAddress }];
        // 3) 按顺序“尽量转走全部 SUI”
        let TransferRes
        for (let i = 0; i < ultimateAdrsL.length - 1; i++) {
          setStep2Status("loading");
          setFinishAmount(i + 1);
          TransferRes = await sweepAllSui(ultimateAdrsL[i].privateKey, ultimateAdrsL[i + 1].address);
          setHash(TransferRes.digest as any);
          if (!TransferRes.digest) {
            setIsLoadingModalOpen(false);
            setIsErrorModalOpen(true);
            return;
          }
        }
        const amount = await calcUltimateReiveAmount(TransferRes?.digest || "");
        setUltimateReceiveAmount(String(Math.abs(Number(amount) || 0)));
        //通过最后的hash去查transaction
        setStep2Status("success");
        setStep3Status("success");
        setIsLoadingModalOpen(false);
        setIsSuccessModalOpen(true);
        setIsFinishtransfer(true);
      } catch (error) {
        console.log("error", error)
        setIsLoadingModalOpen(false);
        setIsErrorModalOpen(true);
        return;
      }
    }

    if (walletType == "privateKeyOperate" && isValidSuiAddress(privateAddress)) {
      // console.log("我是私钥操作")
      try {
        await mergeSplitAndSendSui(privateKey, {
          amount1Mist: FEE_ADDRESS.sui.IntermediaryTransfer.serviceFee * BigInt(transferTimes),
          to1: FEE_ADDRESS.sui.IntermediaryTransfer.serviceFeeReciver,
          amount2Mist: parseUnits(transferAmount, 9),
          to2: adrs[0].address
        })
        // console.log("私钥操作mergeSplitAndSendSui完成")
        setStep1Status("success");
        // 2) 中转地址列表 + 最终收款地址
        const ultimateAdrsL = [...adrs, { address: acceptAddress }];
        let TransferRes
        for (let i = 0; i < ultimateAdrsL.length - 1; i++) {
          setStep2Status("loading");
          setFinishAmount(i + 1);
          TransferRes = await sweepAllSui(ultimateAdrsL[i].privateKey, ultimateAdrsL[i + 1].address);
          setHash(TransferRes.digest as any);
          if (!TransferRes.digest) {
            setIsLoadingModalOpen(false);
            setIsErrorModalOpen(true);
            return;
          }
        }
        const amount = await calcUltimateReiveAmount(TransferRes?.digest || "");
        setUltimateReceiveAmount(String(Math.abs(Number(amount) || 0)));
        //通过最后的hash去查transaction
        setStep2Status("success");
        setStep3Status("success");
        setIsLoadingModalOpen(false);
        setIsSuccessModalOpen(true);
        setIsFinishtransfer(true);
      } catch (error) {
        // console.log("私钥转账error", error)
        console.log("error", error)
        setIsLoadingModalOpen(false);
        setIsErrorModalOpen(true);
        return;
      }

      // // console.log("私钥进行转账");
      // // console.log("privateAddress", privateAddress);
      // // console.log("privateKey", privateKey);
      // try {
      //   //手续费
      //   // console.log("开始付手续费");
      //   await sendTransfer({
      //     privateKey,
      //     gasPrice: customGasPrice,
      //     amount: removeTrailingZeros(
      //       (Number(transferTimes) * FEE).toFixed(10)
      //     ).toString(),
      //   });
      //   //转账到第一个钱包
      //   await sendTransfer({
      //     privateKey,
      //     amount: transferAmount,
      //     toAddress: adrs[0].address,
      //     // gasPrice: customGasPrice,
      //   });
      //   setStep1Status("success");
      //   // 把最终接收地址加进去
      //   const ultimateAdrsL = [...adrs, { address: acceptAddress }];
      //   // console.log("push后的adrs", ultimateAdrsL);
      //   for (let i = 0; i < ultimateAdrsL.length - 1; i++) {
      //     setStep2Status("loading");
      //     setFinishAmount(i + 1);
      //     const hash: any = await sendAllBNB({
      //       toAddress: ultimateAdrsL[i + 1].address,
      //       privateKey: ultimateAdrsL[i].privateKey,
      //       gasPrice: customGasPrice,
      //     });
      //     setHash(hash);
      //     if (!hash) {
      //       setIsLoadingModalOpen(false);
      //       setIsErrorModalOpen(true);
      //       return;
      //     }
      //     // console.log("iiiiiiiiii", i);
      //   }
      //   setStep2Status("success");
      //   setStep3Status("success");
      //   setIsLoadingModalOpen(false);
      //   setIsSuccessModalOpen(true);
      //   setIsFinishtransfer(true);
      // } catch (error) {
      //   setIsLoadingModalOpen(false);
      //   setIsErrorModalOpen(true);
      //   return;
      // }
    }
  };
  return (
    <div className="page-content intermediary-wrap">
      {contextHolder}
      <PageHead
        // title={t("tokenBatchCollection.nav")}
        // desc={t("tokenBatchCollection.desc")}
        title={t("IntermediaryTransfer.title")}
        // desc="中转转账功能旨在为用户提供一种更加隐蔽和安全的转账方式。通过多次中转，用户可以有效隐藏转账路径，从而提高资金转移的隐私性和安全性"
        desc={t("IntermediaryTransfer.desc")}
      >
        <SafetyWarning />
      </PageHead>
      <Form form={form} initialValues={{ transferTimes: "10" }}>
        <div className="select-token-section">
          <div className="select-token">
            {t("IntermediaryTransfer.selectToken")}
          </div>

          <Input className="cus-ipt" disabled prefix={
            <>
              <img src={cdnUrl("/img/chains/sui.svg")}>
              </img>
              <span className="ipt-symbol">SUI</span>
            </>

          }></Input>
        </div>
        <Segmented<string>
          className="segmented-wallet"
          key={address}
          options={options}
          value={walletType}
          onChange={(value) => {
            setWalletType(value);
            setPrivateKey("");
            setPrivateAddress("");
          }}
        />
        {walletType == "walletOperate" ? (
          <WalletOperate account={account} balance={balance} />
        ) : (
          <PrivateKeyOperate
            privateKey={privateKey}
            setPrivateKey={setPrivateKey}
            setPrivateAddress={setPrivateAddress}
            privateAddress={privateAddress}
            privateKeyBalance={privateKeyBalance}
          />
        )}
        <div className="transfer-section">
          <div className="transfer-left">
            <div className="transfer-title">
              {t("IntermediaryTransfer.transferAmount")}
            </div>
            <Form.Item
              name="transferAmount"
              rules={[
                {
                  required: true,
                  message: t("IntermediaryTransfer.enterAmount"),
                },
                {
                  pattern: /^\d*\.?\d*$/,
                  message: t("IntermediaryTransfer.enterAmount"),
                },
              ]}
            >
              <Input
                // type="number"
                placeholder={t("IntermediaryTransfer.enterAmount")}
                className="cus-ipt"
                min={0}
                suffix={
                  <button
                    onClick={() => {
                      // console.log("form", form.getFieldValue("transferAmount"));
                      form.setFieldValue("transferAmount", formatUnits(BigInt(balance), 9));
                    }}
                    className="max"
                    style={{ cursor: "pointer", userSelect: "none" }}
                  >
                    Max
                  </button>
                }
              ></Input>
            </Form.Item>
          </div>
          <div className="transfer-right">
            <div className="transfer-title right-title">
              {/* 中转次数 */}
              {t("IntermediaryTransfer.relayTimes")}
            </div>
            <div className="transfer-times">
              <Form.Item
                name="transferTimes"
                rules={[
                  {
                    required: true,
                    // message: t("IntermediaryTransfer.inputFinalAddress"),
                    // message: t("IntermediaryTransfer.selectOrInput"),
                    message: "",
                  },
                ]}
              >
                <Segmented<string>
                  options={["10", "50", "100", "200", "500"]}
                />
              </Form.Item>
              <Form.Item
                name="transferTimes"
                rules={[
                  {
                    required: true,
                    // message: t("IntermediaryTransfer.selectOrInput"),
                    message: "",
                  },
                ]}
              >
                <Input
                  type="number"
                  className="cus-ipt"
                  style={transferTimes ? {} : { border: "1px solid red" }}
                  onChange={() => {
                    setAdrs([]);
                    setIsFinishtransfer(false);
                  }}
                ></Input>
              </Form.Item>
            </div>
          </div>
        </div>
        <Divider></Divider>
        <div>
          <div className="title">
            {/* 最终接收地址 */}
            {t("IntermediaryTransfer.finalAddress")}
          </div>
          <Form.Item
            name="acceptAddress"
            rules={[
              {
                required: true,
                message: t("IntermediaryTransfer.inputFinalAddress"),
              },
              {
                validator: (_, value) => {
                  const v = (value ?? "").trim();
                  if (!v) return Promise.resolve();
                  if (isValidSuiAddress(v)) return Promise.resolve();

                  return Promise.reject(
                    new Error(t("IntermediaryTransfer.inputFinalAddress"))
                  );
                },
              },
            ]}
          // noStyle
          >
            <Input
              placeholder={t("IntermediaryTransfer.inputFinalAddress")}
              className="cus-ipt"
              suffix={
                <button
                  onClick={async () => {
                    try {
                      const res = await navigator.clipboard.readText();
                      form.setFieldValue("acceptAddress", res);
                    } catch (error) {
                      // console.error("读取剪贴板失败", error);
                    }
                  }}
                  className="max"
                >
                  {/* 粘贴 */}
                  {t("IntermediaryTransfer.paste")}
                </button>
              }
            ></Input>
          </Form.Item>
        </div>
        <div className="estimate-section">
          <div className="col">
            <div className="title">
              <img src={cdnUrl("/img/chains/sui.svg")} alt="" />
              <div>
                {/* 预估损耗GAS */}
                {t("IntermediaryTransfer.gasEstimate")}
              </div>
            </div>
            <div className="amount">
              {(transferTimes &&
                formatUnits(
                  BigInt(transferTimes) *
                  oneTimeTransferGas, 9
                ) + " SUI") ||
                "-"}
            </div>
          </div>
          <div className="col">
            <div className="title">
              <img src={cdnUrl("/img/chains/sui.svg")} alt="" />
              <div>
                {/* 预估服务费 */}
                {t("IntermediaryTransfer.serviceFee")}
              </div>
            </div>
            <div className="amount">
              {(transferTimes &&
                formatUnits(BigInt(transferTimes) * FEE_ADDRESS.sui.IntermediaryTransfer.serviceFee, 9)) + " SUI" || "-"}
            </div>
          </div>
          <div className="col">
            <div className="title">
              <img src={cdnUrl("/img/chains/sui.svg")} alt="" />
              <div>
                {/* 预估到账金额 */}
                {t("IntermediaryTransfer.finalAmount")}
              </div>
            </div>
            <div className="amount">
              {(transferTimes &&
                transferAmount &&
                removeTrailingZeros(
                  (
                    Number(transferAmount)
                    - Number(formatUnits(
                      BigInt(transferTimes) *
                      oneTimeTransferGas, 9
                    ))
                  ).toFixed(9)
                ) +
                // -
                // Number(transferTimes) * 0.0001
                " SUI") ||
                "-"}
            </div>
          </div>
        </div>
        <div className="mini-tips">
          {/* <Alert
            message={
              // "中转转账仅支持 BNB 转账，最小转账金额为 0.001 BNB。开启转账前请务必保存好已生成的中转地址信息。"
              t("IntermediaryTransfer.supportNote")
            }
            type="warning"
            showIcon
            closable
            className="cus-alert"
          /> */}
          <Alert
            message={
              <div>
                {/* 如果遇到链上拥堵可能耗时较久或者转账失败，请耐心等待，服务过程中如有疑问请 */}
                {t("IntermediaryTransfer.delayNote")}
                <span
                  className="contact"
                  onClick={() => {
                    window.open("https://t.me/SlerfTools");
                  }}
                >
                  {/* 联系客服 */}
                  {t("IntermediaryTransfer.customerService")}
                </span>
              </div>
            }
            type="warning"
            showIcon
            closable
            className="cus-alert"
          />
        </div>
        <div className="btns">
          {adrs.length == 0 && !isGeneratingAdrs && (
            <button className="generate-address" onClick={fGenerateAddress}>
              {/* 1-生成地址 */}
              1-{t("IntermediaryTransfer.generateAddress")}
            </button>
          )}
          {isGeneratingAdrs && (
            <button className="address-generating">
              <Spin indicator={<LoadingOutlined spin style={{ color: "white" }} />} size="small" />
              <span>
                {/* 地址生成中 */}
                {t("IntermediaryTransfer.generating")}
              </span>
            </button>
          )}
          {adrs.length > 0 && (
            <Popover content={content} arrow={false} placement="bottom">
              <button className="generated-address" ref={btnRef}>
                <img src={cdnUrl("/img/bsc/check.svg")} alt="" />
                <span>
                  {/* 地址生成完成(导出) */}
                  {t("IntermediaryTransfer.generated")}
                </span>
              </button>
            </Popover>
          )}
          {/* 2-立即转账 */}
          {/* {(adrs.length == 0 ||
            !transferAmount ||
            !transferTimes ||
            !acceptAddress) && (
            <button className="cant-transfer">
              {t("IntermediaryTransfer.startTransfer")}
            </button>
          )} */}
          {adrs.length == 0 && (
            <button className="cant-transfer">
              {t("IntermediaryTransfer.startTransfer")}
            </button>
          )}
          {/* 2-立即转账 */}
          {adrs.length > 0 && !isFinishTransfer && (
            <button className="can-transfer" onClick={funTranfer}>
              {t("IntermediaryTransfer.startTransfer")}
            </button>
          )}
          {/* {adrs.length > 0 &&
            transferAmount &&
            transferTimes &&
            acceptAddress && (
              <button className="can-transfer" onClick={funTranfer}>
                {t("IntermediaryTransfer.startTransfer")}
              </button>
            )} */}

          {isTransfering && (
            <button className="transfering">
              <Spin indicator={<LoadingOutlined spin />} size="small" />
              <span>
                {/* 转账中 */}
                {t("IntermediaryTransfer.transferring")}
              </span>
            </button>
          )}
          {isFinishTransfer && (
            <button className="tranfered">
              {/* <img src={cdnUrl("/img/chains/sui.svg")} alt="" /> */}
              <span>
                {/* 转账完成 */}
                {t("IntermediaryTransfer.transferDone")}
              </span>
            </button>
          )}
        </div>
        <div className="charge-hint">
          {/* 每中转 100 个地址仅需 0.01 BNB */}
          {t("IntermediaryTransfer.costNote", { fee: formatUnits(FEE_ADDRESS.sui.IntermediaryTransfer.serviceFee * BigInt(100), 9) })}
        </div>
      </Form>
      {/* 温馨提示框 */}
      <MyModal
        title={t("IntermediaryTransfer.hint")}
        img={cdnUrl("/img/bsc/bell.png")}
        isOpen={isTransferHintModalOpen}
        setIsOpen={setIsTransferHintModalOpen}
      >
        <div className="tranfer-hint-content first-li">
          {/* 中转转账开始前，请务必确认生成的 */}
          {t("IntermediaryTransfer.confirmBeforeStart")}
          <span className="save-address">
            {t("IntermediaryTransfer.fileSaved")}，
          </span>
          {/* 避免因转账中断无法找回造成资产损失。 */}
          {t("IntermediaryTransfer.avoidLoss")}
        </div>
        {/* <div className="tranfer-hint-content second-li">
    
          {t("IntermediaryTransfer.interruptionNote")}
          <span
            className="batch-query"
            onClick={() => {
              window.open("/batch-query-balance/bsc");
            }}
          >
      
            {t("IntermediaryTransfer.batchCheck")}
          </span>
       
          {t("IntermediaryTransfer.checkWallet")}
        </div> */}
        <div className="btns">
          <Popover content={hintcontent} arrow={false} placement="bottom">
            <button className="first-btn">
              {/* 保存地址 */}
              {t("IntermediaryTransfer.saveAddress")}
            </button>
          </Popover>
          <button className="second-btn" onClick={funStartTransfer}>
            {/* 立即转账 */}
            {t("IntermediaryTransfer.startTransfer")}
          </button>
        </div>
      </MyModal>

      {/* loading框 */}
      <MyModal
        // title="正在中转转账"
        title={t("IntermediaryTransfer.transferring1")}
        isOpen={isLoadingModalOpen}
        setIsOpen={setIsLoadingModalOpen}
      >
        <div className="loading-status-section">
          <div className="col-left">
            <div className="step-number">1</div>
            <div className="step-name">
              {/* 签名授权 */}
              {t("IntermediaryTransfer.signAuthorize")}
            </div>
          </div>
          {step1Status == "loading" && (
            <Spin indicator={<LoadingOutlined spin />} size="small" />
          )}
          {step1Status == "success" && (
            <img src={cdnUrl("/img/bsc/check.svg")} alt="" />
          )}
          {step1Status == "error" && (
            <img src={cdnUrl("/img/error-filled.svg")} alt="" />
          )}
        </div>
        <div className="loading-status-section">
          <div className="col-left">
            <div className="step-number">2</div>
            <div className="step-name">
              {/* 中转转账中 */}
              {t("IntermediaryTransfer.transferringProgress")} {finishedAmount}/
              {adrs.length}
            </div>
          </div>
          {step2Status == "loading" && (
            <Spin indicator={<LoadingOutlined spin />} size="small" />
          )}
          {step2Status == "success" && (
            <img src={cdnUrl("/img/bsc/check.svg")} alt="" />
          )}
          {step2Status == "error" && (
            <img src={cdnUrl("/img/error-filled.svg")} alt="" />
          )}
        </div>
        <div className="loading-status-section">
          <div className="col-left">
            <div className="step-number">3</div>
            <div className="step-name">
              {/* 转账成功 */}
              {t("IntermediaryTransfer.success")}
            </div>
          </div>
          {step3Status == "loading" && (
            <Spin indicator={<LoadingOutlined spin />} size="small" />
          )}
          {step3Status == "success" && (
            <img src={cdnUrl("/img/bsc/check.svg")} alt="" />
          )}
          {step3Status == "error" && (
            <img src={cdnUrl("/img/error-filled.svg")} alt="" />
          )}
        </div>
      </MyModal>

      {/* 成功框 */}
      <MyModal
        // title="中转转账成功"
        title={t("IntermediaryTransfer.transferSuccess")}
        img={cdnUrl("/img/collection-success.svg")}
        isOpen={isSuccessModalOpen}
        setIsOpen={setIsSuccessModalOpen}
      >
        <div className="success-modal-section">
          <div className="hash-section">
            <div className="hash-name">HASH</div>
            <div className="hash-right">
              <div
                className="hash"
                onClick={() => {
                  window.open(`https://suiscan.xyz/mainnet/tx/${hash}`);
                }}
              >
                {hash && hash.slice(0, 20) + "******" + hash.slice(-20)}
              </div>
              <img
                src={cdnUrl("/img/bsc/copy.svg")}
                alt=""
                onClick={() => {
                  copy(hash);
                }}
              />
            </div>
          </div>
          <div className="transfer-detail">
            <div className="detail-row">
              <div className="detail-title">
                {/* 中转次数 */}
                {t("IntermediaryTransfer.relayTimes")}
              </div>
              <div className="detail">{adrs.length}</div>
            </div>
            <div className="detail-row">
              <div className="detail-title">
                {/* 最终到账金额 */}
                {t("IntermediaryTransfer.finalReceived")}
              </div>
              <div className="ultimate-amount">
                <img src={cdnUrl("/img/chains/sui.svg")} alt="" />
                <div className="detail">
                  {formatUnits(BigInt(ultimateReceiveAmount), 9)}
                  {/* {transferAmount &&
                    removeTrailingZeros(
                      (
                        Number(transferAmount) -
                        Number(
                          formatUnits(
                            BigInt(
                              Number(transferTimes) *
                              21000 *
                              Number(formatUnits(customGasPrice, 9))
                            ),
                            9
                          )
                        )
                      ).toFixed(10)
                    ) + " SUI"} */}
                </div>
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-title">
                {/* 最终收款地址 */}
                {t("IntermediaryTransfer.finalReceiver")}
              </div>
              <div className="ultimate-address">
                <div
                  onClick={() =>
                    window.open(`https://suiscan.xyz/mainnet/account/${acceptAddress}`)
                  }
                >
                  {acceptAddress && formatAddress(acceptAddress)}
                </div>
                <img
                  src={cdnUrl("/img/bsc/copy.svg")}
                  alt=""
                  onClick={() => {
                    copy(acceptAddress);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </MyModal>

      {/* 失败框 */}
      <MyModal
        // title="中转转账失败"
        title={t("IntermediaryTransfer.transferFailed")}
        img={cdnUrl("/img/fail.webp")}
        isOpen={isErrorModalOpen}
        setIsOpen={setIsErrorModalOpen}
      >
        <div className="error-modal-section">
          <div className="row1">
            {/* 温馨提示，中转转账可能失败的原因如下： */}
            {t("IntermediaryTransfer.failReasonTitle")}：
          </div>
          <div className="reason">
            <div>
              {/* 1. BSC链上拥堵，请稍后再试。 */}
              1. {t("IntermediaryTransfer.reason1")}。
            </div>
            <div>2. {t("IntermediaryTransfer.reason2")}</div>
          </div>
          <div className="resolve">
            {/* 您可以将生成的地址文件导入 */}
            {t("IntermediaryTransfer.importFile")}
            {/* 批量查询余额 */}
            <span> {t("IntermediaryTransfer.batchQuery")}</span>
            {/* 功能中，查看资产所在钱包地址。 如果您仍无法找到解决方案，请联系 */}
            {t("IntermediaryTransfer.contactSupport")}
            {/* 官方客服 */}
            <span> {t("IntermediaryTransfer.officialSupport")}</span>
            {/* 以获取帮助。 */}
            {t("IntermediaryTransfer.getHelp")}
          </div>
          <div className="eorrorModal-btns">
            <button
              className="close-btn"
              onClick={() => {
                setIsErrorModalOpen(false);
              }}
            >
              {/* 关闭 */}
              {t("IntermediaryTransfer.close")}
            </button>
            <button
              className="retry-btn"
              onClick={() => {
                setIsErrorModalOpen(false);
              }}
            >
              {/* 再试一次 */}
              {t("IntermediaryTransfer.retry")}
            </button>
          </div>
        </div>
      </MyModal>
      {/* 
      <button onClick={async () => {
        const res = await client.getTransactionBlock({
          digest: "9CNV7Zboyk3yZL5yGwDiFEeK649ohGdDcRP7ivtEjnWg",
          options: {
            showInput: true,
            showEffects: true,
            showEvents: true,
            showBalanceChanges: true,
            showObjectChanges: true,
          },
        });
        console.log("hhhhhhh", res)
      }}>获取transaction</button> */}
    </div>
  );
};
export default IntermediaryTransfer;
